import jwtDecode from "jwt-decode";
import http from "./httpService";

const apiEndpoint = http.apiUrl + "user-auth";
const deleteApiEndpoint = http.apiUrl + "user";

function deleteUserURl(id) {
  return `${deleteApiEndpoint}/${id}`;
}

const tokenKey = "token";

export function login(emailObject) {
  return http.post(apiEndpoint, emailObject);
}

export function sendOTpToClient(emailObject) {
  return http.post(apiEndpoint + "/sent-otp", emailObject);
}

export function verifyOtp(otpObject) {
  return http.post(apiEndpoint + "/varify-user-otp", otpObject);
}

export function deleteUserAccount(id, token) {
  return http.delete(deleteUserURl(id), {
    headers: {
      "x-auth-token": token,
    },
  });
}

export function getCurrentUser() {
  try {
    const jwt = sessionStorage.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

export function validateToken(jwt) {
  try {
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

const authObject = {
  login,
  getCurrentUser,
};

export default authObject;
